// extracted by mini-css-extract-plugin
export var cookieBanner = "BaseLayout-module--cookieBanner--ad444";
export var loader = "BaseLayout-module--loader--5b08c";